export class ApplicantType {

    public static readonly EMPLOYEE: string = 'Employee';
    public static readonly SPOUSE: string = 'Spouse';
    public static readonly CHILD: string = 'Child';
    
    abbreviation: string;
    label: string;
}